#import "../fragments/contact-for-core-entity-fragment.graphql"

mutation CreateContactForCoreEntity($input: ContactCreateInput!) {
    contactCreate(input: $input) {
        contact {
            ...ContactForCoreEntityFragment
        }
    }
}
